export default __webpack_public_path__ + "static/media/add-gradient.4f26c181.svg";